// src/services/works/detailImageMin.js
//
// 상세이미지 최소 크기 — 쿠팡 서플라이어허브는 780×500px 미만 상세이미지를 반려한다(002 · PR261021-C2CA3A daycozy01 ·
// 카테고리 스키마 «사이즈 및 용량 : 가로, 세로 780 x 500px 이상»). 등록 전송 두 길이 이 파일 하나를 쓴다 —
// 화면(AIRocketReg submitProductsToCoupang)과 도구(tool-exec/rocket-submit.js · data: 모듈로 올림). 잣대·말을 두 벌 두지 않는다.
// 크기를 못 읽으면 보내지 않는다 — 지어낸 크기 0(옛 detailImageService.getImageDimensions 는 오류 때 800×600 을 지어냈다).

export const DETAIL_MIN = { width: 780, height: 500 };
export const MEASURE_TIMEOUT_MS = 15000;

/** 쿠팡 문서(coupangDoc)의 상세이미지 주소 — 옵션마다 쉼표로 이은 글을 쪼개 겹침을 뺀다 */
export function detailImageUrls(doc) {
  const all = ((doc && doc.jsonDocument) || []).flatMap(o => String((o && o.imagePage && o.imagePage.details && o.imagePage.details.detailedImage) || '').split(','));
  return [...new Set(all.map(u => u.trim()).filter(Boolean))];
}

// 대표이미지 — 허브는 «최소 400×400 최대 8000×8000» 밖이면 요청 단계에서 반려한다(PEACH PR261028-937D6E 360×360).
// 올릴 때 서버가 맞추지만(lib/rocket-main-image.js) 올리기 실패 때 1688 원본 주소가 그대로 남는 길이 있어 보내기 전에도 잰다.
export const MAIN_MIN = 400;
export const MAIN_MAX = 8000;

/** 쿠팡 문서(coupangDoc)의 대표이미지 주소 — 옵션마다 · 겹침 뺌 */
export function mainImageUrls(doc) {
  const all = ((doc && doc.jsonDocument) || []).flatMap(o => String((o && o.imagePage && o.imagePage.images && o.imagePage.images.mainImage) || '').split(','));
  return [...new Set(all.map(u => u.trim()).filter(Boolean))];
}

/** @returns {string|null} 보내지 않는 까닭(통과면 null) */
export function mainSizeReason(url, size) {
  const at = `대표이미지(${fileOf(url)})`;
  const redo = `rocket.sourcing.runWork 를 tasks:['mainImage'] 로 다시 돌려 대표이미지를 새로 지은 뒤 다시 보내세요.`;
  if (!size) return `${at}의 크기를 읽지 못해 보내지 않았습니다(받기 실패 또는 모르는 그림 꼴). ${redo}`;
  if (Math.min(size[0], size[1]) < MAIN_MIN || Math.max(size[0], size[1]) > MAIN_MAX) {
    return `${at}가 ${size[0]}×${size[1]}px 이라 쿠팡 기준(최소 ${MAIN_MIN}×${MAIN_MIN}px · 최대 ${MAIN_MAX}×${MAIN_MAX}px) 밖이어서 보내지 않았습니다(보내면 요청 단계에서 반려). ${redo}`;
  }
  return null;
}

/** 기록 크기 칸 «가로x세로» — 잰 값만 · 못 잼(null·0) = 빈 칸(지어낸 800x800 0) */
export function dimensionsText(size) {
  return size && size.width > 0 && size.height > 0 ? `${size.width}x${size.height}` : '';
}

export const fileOf = url => (String(url).split('?')[0].split('/').pop() || '이름 없음').slice(0, 60);

/**
 * @param {number} index 0부터 · @param {string} url · @param {[number, number]|null} size 잰 가로·세로(못 읽음 = null)
 * @returns {string|null} 보내지 않는 까닭(통과면 null)
 */
export function detailSizeReason(index, url, size) {
  const at = `상세이미지 ${index + 1}번째(${fileOf(url)})`;
  if (!size) return `${at}의 크기를 읽지 못해 보내지 않았습니다(받기 실패 또는 모르는 그림 꼴). 이미지 주소가 열리는지 확인한 뒤 다시 보내세요.`;
  if (size[0] < DETAIL_MIN.width || size[1] < DETAIL_MIN.height) {
    return `${at}가 ${size[0]}×${size[1]}px 이라 쿠팡 최소 ${DETAIL_MIN.width}×${DETAIL_MIN.height}px 에 못 미쳐 보내지 않았습니다. 상세이미지 작업을 다시 돌리거나 이미지를 바꿔 저장한 뒤 다시 보내세요.`;
  }
  return null;
}

/**
 * 화면용 — 그림을 불러 실제 가로·세로(naturalWidth/Height)를 잰다. 남의 도메인이어도 CORS 없이 된다.
 * 불러오기 실패·시간 넘김이면 null(지어낸 크기 0). ImageCtor 는 브라우저 Image(시험은 가짜를 넣는다)
 * @returns {Promise<[number, number]|null>}
 */
export function measureImage(ImageCtor, url, timeoutMs = MEASURE_TIMEOUT_MS) {
  return new Promise((resolve) => {
    let done = false;
    const end = (v) => { if (!done) { done = true; clearTimeout(timer); resolve(v); } };
    const timer = setTimeout(() => { console.error('[detailImageMin] 상세이미지 크기 재기 시간 넘김:', fileOf(url)); end(null); }, timeoutMs);
    const img = new ImageCtor();
    img.onload = () => end(img.naturalWidth > 0 && img.naturalHeight > 0 ? [img.naturalWidth, img.naturalHeight] : null);
    img.onerror = () => { console.error('[detailImageMin] 상세이미지 불러오기 실패:', fileOf(url)); end(null); };
    img.src = url;
  });
}
